var _feComposite, _feColorMatrix, _feFlood, _feBlend, _feBlend2, _feColorMatrix2, _feComposite2, _feColorMatrix3, _feComposite3, _feColorMatrix4, _feFlood2, _feBlend3, _feBlend4, _feColorMatrix5, _feComposite4, _feComposite5, _feColorMatrix6, _feFlood3, _feBlend5, _feBlend6, _feColorMatrix7, _feComposite6, _feColorMatrix8, _feComposite7, _feColorMatrix9, _feFlood4, _feBlend7, _feBlend8, _feColorMatrix10, _feComposite8, _feComposite9, _feColorMatrix11, _feFlood5, _feBlend9, _feBlend10, _feColorMatrix12, _feComposite10, _feColorMatrix13, _feComposite11, _feColorMatrix14, _feFlood6, _feBlend11, _feBlend12, _feColorMatrix15, _feComposite12, _feComposite13, _feColorMatrix16, _feFlood7, _feBlend13, _feBlend14, _feColorMatrix17, _feComposite14, _feColorMatrix18, _feComposite15, _feColorMatrix19, _feFlood8, _feBlend15, _feBlend16, _feColorMatrix20, _feComposite16, _feComposite17, _feColorMatrix21, _feFlood9, _feBlend17, _feBlend18, _feColorMatrix22, _feComposite18, _feColorMatrix23, _feComposite19, _feColorMatrix24, _feFlood10, _feBlend19, _feBlend20, _feColorMatrix25, _feComposite20, _feComposite21, _feColorMatrix26, _feFlood11, _feBlend21, _feBlend22, _feColorMatrix27, _feComposite22, _feColorMatrix28, _feComposite23, _feColorMatrix29, _feFlood12, _feBlend23, _feBlend24, _feColorMatrix30, _feComposite24, _feComposite25, _feColorMatrix31, _feFlood13, _feBlend25, _feBlend26, _feColorMatrix32, _feComposite26, _feColorMatrix33, _feComposite27, _feColorMatrix34, _feFlood14, _feBlend27, _feBlend28, _feColorMatrix35, _feComposite28, _feComposite29, _feColorMatrix36, _feFlood15, _feBlend29, _feBlend30, _feColorMatrix37, _feComposite30, _feColorMatrix38, _feComposite31, _feColorMatrix39, _feFlood16, _feBlend31, _feBlend32, _feColorMatrix40, _feComposite32, _feComposite33, _feColorMatrix41, _feFlood17, _feBlend33, _feBlend34, _feColorMatrix42, _feComposite34, _feColorMatrix43, _feComposite35, _feColorMatrix44, _feFlood18, _feBlend35, _feBlend36, _feColorMatrix45, _feComposite36, _feComposite37, _feColorMatrix46, _feFlood19, _feBlend37, _feBlend38, _feColorMatrix47, _feComposite38, _feColorMatrix48, _feComposite39, _feColorMatrix49, _feFlood20, _feBlend39, _feBlend40, _feColorMatrix50, _feComposite40, _feComposite41, _feColorMatrix51, _feFlood21, _feBlend41, _feBlend42, _feColorMatrix52, _feComposite42, _feColorMatrix53, _feComposite43, _feColorMatrix54, _feFlood22, _feBlend43, _feBlend44, _feColorMatrix55, _feComposite44, _feComposite45, _feColorMatrix56, _feFlood23, _feBlend45, _feBlend46, _feColorMatrix57, _feComposite46, _feColorMatrix58, _feComposite47, _feColorMatrix59, _feFlood24, _feBlend47, _feBlend48, _feColorMatrix60, _feComposite48, _feComposite49, _feColorMatrix61, _feFlood25, _feBlend49, _feBlend50, _feColorMatrix62, _feComposite50, _feColorMatrix63, _feComposite51, _feColorMatrix64, _feFlood26, _feBlend51, _feBlend52, _feColorMatrix65, _feComposite52, _feComposite53, _feColorMatrix66, _feFlood27, _feBlend53, _feBlend54, _feColorMatrix67, _feComposite54, _feColorMatrix68, _feComposite55, _feColorMatrix69, _feFlood28, _feBlend55, _feBlend56, _feColorMatrix70, _feComposite56, _feComposite57, _feColorMatrix71, _feFlood29, _feBlend57, _feBlend58, _feColorMatrix72, _feComposite58, _feColorMatrix73, _feComposite59, _feColorMatrix74, _feFlood30, _feBlend59, _feBlend60, _feColorMatrix75, _feComposite60, _feComposite61, _feColorMatrix76, _feFlood31, _feBlend61, _feBlend62, _feColorMatrix77, _feComposite62, _feColorMatrix78, _feComposite63, _feColorMatrix79, _feFlood32, _feBlend63, _feBlend64, _feColorMatrix80, _feComposite64, _feComposite65, _feColorMatrix81, _feFlood33, _feBlend65, _feBlend66, _feColorMatrix82, _feComposite66, _feColorMatrix83, _feComposite67, _feColorMatrix84, _feFlood34, _feBlend67, _feBlend68, _feColorMatrix85, _feComposite68, _feComposite69, _feColorMatrix86, _feFlood35, _feBlend69, _feBlend70, _feColorMatrix87, _feComposite70, _feColorMatrix88, _feComposite71, _feColorMatrix89, _feFlood36, _feBlend71, _feBlend72, _feColorMatrix90, _feComposite72, _feComposite73, _feColorMatrix91, _feFlood37, _feBlend73, _feBlend74, _feColorMatrix92, _feComposite74, _feColorMatrix93, _feComposite75, _feColorMatrix94, _feFlood38, _feBlend75, _feBlend76, _feColorMatrix95, _feComposite76, _feComposite77, _feColorMatrix96, _feFlood39, _feBlend77, _feBlend78, _feColorMatrix97, _feComposite78, _feColorMatrix98, _feComposite79, _feColorMatrix99, _feFlood40, _feBlend79, _feBlend80, _feColorMatrix100, _feComposite80, _feComposite81, _feColorMatrix101, _feFlood41, _feBlend81, _feBlend82, _feColorMatrix102, _feComposite82, _feColorMatrix103, _feComposite83, _feColorMatrix104, _feFlood42, _feBlend83, _feBlend84, _feColorMatrix105, _feComposite84, _feComposite85, _feColorMatrix106, _feFlood43, _feBlend85, _feBlend86, _feColorMatrix107, _feComposite86, _feColorMatrix108, _feComposite87, _feColorMatrix109, _feFlood44, _feBlend87, _feBlend88, _feColorMatrix110, _feComposite88, _feComposite89, _feColorMatrix111, _feFlood45, _feBlend89, _feBlend90, _feColorMatrix112, _feComposite90, _feColorMatrix113, _feComposite91, _feColorMatrix114, _feFlood46, _feBlend91, _feBlend92, _feColorMatrix115, _feComposite92, _feComposite93, _feColorMatrix116, _feFlood47, _feBlend93, _feBlend94, _feColorMatrix117, _feComposite94, _feColorMatrix118, _feComposite95, _feColorMatrix119, _feFlood48, _feBlend95, _feBlend96, _feColorMatrix120, _feComposite96, _feComposite97, _feColorMatrix121, _feFlood49, _feBlend97, _feBlend98, _feColorMatrix122, _feComposite98, _feColorMatrix123, _feComposite99, _feColorMatrix124, _feFlood50, _feBlend99, _feBlend100, _feColorMatrix125, _feComposite100, _feComposite101, _feColorMatrix126, _feFlood51, _feBlend101, _feBlend102, _feColorMatrix127, _feComposite102, _feColorMatrix128, _feComposite103, _feColorMatrix129, _feFlood52, _feBlend103, _feBlend104, _feColorMatrix130, _feComposite104, _feComposite105, _feColorMatrix131, _feFlood53, _feBlend105, _feBlend106, _feColorMatrix132, _feComposite106, _feColorMatrix133, _feComposite107, _feColorMatrix134, _feFlood54, _feBlend107, _feBlend108, _feColorMatrix135, _feComposite108, _feComposite109, _feColorMatrix136, _feFlood55, _feBlend109, _feBlend110, _feColorMatrix137, _feComposite110, _feColorMatrix138, _feComposite111, _feColorMatrix139, _feFlood56, _feBlend111, _feBlend112, _feColorMatrix140, _feComposite112, _feComposite113, _feColorMatrix141, _feFlood57, _feBlend113, _feBlend114, _feColorMatrix142, _feComposite114, _feColorMatrix143, _feComposite115, _feColorMatrix144, _feFlood58, _feBlend115, _feBlend116, _feColorMatrix145, _feComposite116;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.425,
    height: 152.425,
    viewBox: "0 0 40.329 40.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite || (_feComposite = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood || (_feFlood = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite2 || (_feComposite2 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite3 || (_feComposite3 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix4 || (_feColorMatrix4 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood2 || (_feFlood2 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix5 || (_feColorMatrix5 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite4 || (_feComposite4 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite5 || (_feComposite5 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix6 || (_feColorMatrix6 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood3 || (_feFlood3 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix7 || (_feColorMatrix7 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite6 || (_feComposite6 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix8 || (_feColorMatrix8 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite7 || (_feComposite7 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix9 || (_feColorMatrix9 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood4 || (_feFlood4 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix10 || (_feColorMatrix10 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite8 || (_feComposite8 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite9 || (_feComposite9 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix11 || (_feColorMatrix11 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood5 || (_feFlood5 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix12 || (_feColorMatrix12 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite10 || (_feComposite10 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix13 || (_feColorMatrix13 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite11 || (_feComposite11 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix14 || (_feColorMatrix14 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood6 || (_feFlood6 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix15 || (_feColorMatrix15 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite12 || (_feComposite12 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite13 || (_feComposite13 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix16 || (_feColorMatrix16 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood7 || (_feFlood7 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix17 || (_feColorMatrix17 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite14 || (_feComposite14 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix18 || (_feColorMatrix18 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite15 || (_feComposite15 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix19 || (_feColorMatrix19 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood8 || (_feFlood8 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix20 || (_feColorMatrix20 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite16 || (_feComposite16 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite17 || (_feComposite17 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix21 || (_feColorMatrix21 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood9 || (_feFlood9 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix22 || (_feColorMatrix22 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite18 || (_feComposite18 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix23 || (_feColorMatrix23 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite19 || (_feComposite19 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix24 || (_feColorMatrix24 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood10 || (_feFlood10 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix25 || (_feColorMatrix25 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite20 || (_feComposite20 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite21 || (_feComposite21 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix26 || (_feColorMatrix26 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood11 || (_feFlood11 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix27 || (_feColorMatrix27 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite22 || (_feComposite22 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix28 || (_feColorMatrix28 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite23 || (_feComposite23 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix29 || (_feColorMatrix29 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood12 || (_feFlood12 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix30 || (_feColorMatrix30 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite24 || (_feComposite24 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite25 || (_feComposite25 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix31 || (_feColorMatrix31 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood13 || (_feFlood13 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix32 || (_feColorMatrix32 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite26 || (_feComposite26 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix33 || (_feColorMatrix33 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite27 || (_feComposite27 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix34 || (_feColorMatrix34 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood14 || (_feFlood14 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix35 || (_feColorMatrix35 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite28 || (_feComposite28 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite29 || (_feComposite29 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix36 || (_feColorMatrix36 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood15 || (_feFlood15 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix37 || (_feColorMatrix37 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite30 || (_feComposite30 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix38 || (_feColorMatrix38 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite31 || (_feComposite31 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix39 || (_feColorMatrix39 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood16 || (_feFlood16 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix40 || (_feColorMatrix40 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite32 || (_feComposite32 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite33 || (_feComposite33 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix41 || (_feColorMatrix41 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood17 || (_feFlood17 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend33 || (_feBlend33 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend34 || (_feBlend34 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix42 || (_feColorMatrix42 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite34 || (_feComposite34 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix43 || (_feColorMatrix43 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite35 || (_feComposite35 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix44 || (_feColorMatrix44 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood18 || (_feFlood18 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend35 || (_feBlend35 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend36 || (_feBlend36 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix45 || (_feColorMatrix45 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite36 || (_feComposite36 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite37 || (_feComposite37 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix46 || (_feColorMatrix46 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood19 || (_feFlood19 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend37 || (_feBlend37 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend38 || (_feBlend38 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix47 || (_feColorMatrix47 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite38 || (_feComposite38 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix48 || (_feColorMatrix48 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite39 || (_feComposite39 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix49 || (_feColorMatrix49 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood20 || (_feFlood20 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend39 || (_feBlend39 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend40 || (_feBlend40 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix50 || (_feColorMatrix50 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite40 || (_feComposite40 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite41 || (_feComposite41 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix51 || (_feColorMatrix51 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood21 || (_feFlood21 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend41 || (_feBlend41 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend42 || (_feBlend42 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix52 || (_feColorMatrix52 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite42 || (_feComposite42 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix53 || (_feColorMatrix53 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite43 || (_feComposite43 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix54 || (_feColorMatrix54 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood22 || (_feFlood22 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend43 || (_feBlend43 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend44 || (_feBlend44 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix55 || (_feColorMatrix55 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite44 || (_feComposite44 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "l",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite45 || (_feComposite45 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix56 || (_feColorMatrix56 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood23 || (_feFlood23 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend45 || (_feBlend45 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend46 || (_feBlend46 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix57 || (_feColorMatrix57 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite46 || (_feComposite46 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix58 || (_feColorMatrix58 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite47 || (_feComposite47 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix59 || (_feColorMatrix59 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood24 || (_feFlood24 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend47 || (_feBlend47 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend48 || (_feBlend48 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix60 || (_feColorMatrix60 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite48 || (_feComposite48 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite49 || (_feComposite49 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix61 || (_feColorMatrix61 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood25 || (_feFlood25 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend49 || (_feBlend49 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend50 || (_feBlend50 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix62 || (_feColorMatrix62 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite50 || (_feComposite50 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix63 || (_feColorMatrix63 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite51 || (_feComposite51 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix64 || (_feColorMatrix64 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood26 || (_feFlood26 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend51 || (_feBlend51 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend52 || (_feBlend52 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix65 || (_feColorMatrix65 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite52 || (_feComposite52 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite53 || (_feComposite53 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix66 || (_feColorMatrix66 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood27 || (_feFlood27 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend53 || (_feBlend53 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend54 || (_feBlend54 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix67 || (_feColorMatrix67 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite54 || (_feComposite54 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix68 || (_feColorMatrix68 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite55 || (_feComposite55 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix69 || (_feColorMatrix69 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood28 || (_feFlood28 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend55 || (_feBlend55 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend56 || (_feBlend56 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix70 || (_feColorMatrix70 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite56 || (_feComposite56 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite57 || (_feComposite57 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix71 || (_feColorMatrix71 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood29 || (_feFlood29 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend57 || (_feBlend57 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend58 || (_feBlend58 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix72 || (_feColorMatrix72 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite58 || (_feComposite58 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix73 || (_feColorMatrix73 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite59 || (_feComposite59 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix74 || (_feColorMatrix74 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood30 || (_feFlood30 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend59 || (_feBlend59 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend60 || (_feBlend60 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix75 || (_feColorMatrix75 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite60 || (_feComposite60 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "p",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite61 || (_feComposite61 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix76 || (_feColorMatrix76 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood31 || (_feFlood31 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend61 || (_feBlend61 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend62 || (_feBlend62 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix77 || (_feColorMatrix77 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite62 || (_feComposite62 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix78 || (_feColorMatrix78 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite63 || (_feComposite63 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix79 || (_feColorMatrix79 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood32 || (_feFlood32 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend63 || (_feBlend63 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend64 || (_feBlend64 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix80 || (_feColorMatrix80 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite64 || (_feComposite64 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite65 || (_feComposite65 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix81 || (_feColorMatrix81 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood33 || (_feFlood33 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend65 || (_feBlend65 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend66 || (_feBlend66 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix82 || (_feColorMatrix82 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite66 || (_feComposite66 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix83 || (_feColorMatrix83 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite67 || (_feComposite67 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix84 || (_feColorMatrix84 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood34 || (_feFlood34 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend67 || (_feBlend67 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend68 || (_feBlend68 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix85 || (_feColorMatrix85 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite68 || (_feComposite68 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite69 || (_feComposite69 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix86 || (_feColorMatrix86 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood35 || (_feFlood35 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend69 || (_feBlend69 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend70 || (_feBlend70 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix87 || (_feColorMatrix87 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite70 || (_feComposite70 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix88 || (_feColorMatrix88 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite71 || (_feComposite71 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix89 || (_feColorMatrix89 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood36 || (_feFlood36 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend71 || (_feBlend71 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend72 || (_feBlend72 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix90 || (_feColorMatrix90 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite72 || (_feComposite72 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "s",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite73 || (_feComposite73 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix91 || (_feColorMatrix91 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood37 || (_feFlood37 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend73 || (_feBlend73 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend74 || (_feBlend74 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix92 || (_feColorMatrix92 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite74 || (_feComposite74 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix93 || (_feColorMatrix93 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite75 || (_feComposite75 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix94 || (_feColorMatrix94 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood38 || (_feFlood38 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend75 || (_feBlend75 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend76 || (_feBlend76 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix95 || (_feColorMatrix95 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite76 || (_feComposite76 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite77 || (_feComposite77 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix96 || (_feColorMatrix96 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood39 || (_feFlood39 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend77 || (_feBlend77 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend78 || (_feBlend78 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix97 || (_feColorMatrix97 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite78 || (_feComposite78 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix98 || (_feColorMatrix98 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite79 || (_feComposite79 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix99 || (_feColorMatrix99 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood40 || (_feFlood40 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend79 || (_feBlend79 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend80 || (_feBlend80 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix100 || (_feColorMatrix100 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite80 || (_feComposite80 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "u",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite81 || (_feComposite81 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix101 || (_feColorMatrix101 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood41 || (_feFlood41 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend81 || (_feBlend81 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend82 || (_feBlend82 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix102 || (_feColorMatrix102 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite82 || (_feComposite82 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix103 || (_feColorMatrix103 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite83 || (_feComposite83 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix104 || (_feColorMatrix104 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood42 || (_feFlood42 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend83 || (_feBlend83 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend84 || (_feBlend84 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix105 || (_feColorMatrix105 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite84 || (_feComposite84 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "v",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite85 || (_feComposite85 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix106 || (_feColorMatrix106 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood43 || (_feFlood43 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend85 || (_feBlend85 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend86 || (_feBlend86 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix107 || (_feColorMatrix107 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite86 || (_feComposite86 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix108 || (_feColorMatrix108 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite87 || (_feComposite87 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix109 || (_feColorMatrix109 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood44 || (_feFlood44 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend87 || (_feBlend87 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend88 || (_feBlend88 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix110 || (_feColorMatrix110 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite88 || (_feComposite88 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "w",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite89 || (_feComposite89 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix111 || (_feColorMatrix111 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood45 || (_feFlood45 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend89 || (_feBlend89 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend90 || (_feBlend90 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix112 || (_feColorMatrix112 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite90 || (_feComposite90 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix113 || (_feColorMatrix113 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite91 || (_feComposite91 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix114 || (_feColorMatrix114 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood46 || (_feFlood46 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend91 || (_feBlend91 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend92 || (_feBlend92 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix115 || (_feColorMatrix115 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite92 || (_feComposite92 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "x",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite93 || (_feComposite93 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix116 || (_feColorMatrix116 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood47 || (_feFlood47 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend93 || (_feBlend93 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend94 || (_feBlend94 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix117 || (_feColorMatrix117 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite94 || (_feComposite94 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix118 || (_feColorMatrix118 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite95 || (_feComposite95 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix119 || (_feColorMatrix119 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood48 || (_feFlood48 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend95 || (_feBlend95 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend96 || (_feBlend96 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix120 || (_feColorMatrix120 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite96 || (_feComposite96 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "y",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite97 || (_feComposite97 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix121 || (_feColorMatrix121 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood49 || (_feFlood49 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend97 || (_feBlend97 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend98 || (_feBlend98 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix122 || (_feColorMatrix122 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite98 || (_feComposite98 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix123 || (_feColorMatrix123 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite99 || (_feComposite99 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix124 || (_feColorMatrix124 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood50 || (_feFlood50 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend99 || (_feBlend99 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend100 || (_feBlend100 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix125 || (_feColorMatrix125 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite100 || (_feComposite100 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "z",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite101 || (_feComposite101 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix126 || (_feColorMatrix126 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood51 || (_feFlood51 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend101 || (_feBlend101 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend102 || (_feBlend102 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix127 || (_feColorMatrix127 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite102 || (_feComposite102 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix128 || (_feColorMatrix128 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite103 || (_feComposite103 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix129 || (_feColorMatrix129 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood52 || (_feFlood52 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend103 || (_feBlend103 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend104 || (_feBlend104 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix130 || (_feColorMatrix130 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite104 || (_feComposite104 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "A",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite105 || (_feComposite105 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix131 || (_feColorMatrix131 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood53 || (_feFlood53 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend105 || (_feBlend105 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend106 || (_feBlend106 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix132 || (_feColorMatrix132 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite106 || (_feComposite106 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix133 || (_feColorMatrix133 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite107 || (_feComposite107 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix134 || (_feColorMatrix134 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood54 || (_feFlood54 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend107 || (_feBlend107 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend108 || (_feBlend108 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix135 || (_feColorMatrix135 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite108 || (_feComposite108 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "B",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite109 || (_feComposite109 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix136 || (_feColorMatrix136 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood55 || (_feFlood55 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend109 || (_feBlend109 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend110 || (_feBlend110 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix137 || (_feColorMatrix137 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite110 || (_feComposite110 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix138 || (_feColorMatrix138 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite111 || (_feComposite111 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix139 || (_feColorMatrix139 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood56 || (_feFlood56 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend111 || (_feBlend111 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend112 || (_feBlend112 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix140 || (_feColorMatrix140 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite112 || (_feComposite112 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "C",
    width: 1,
    height: 1,
    x: 0,
    y: 0,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feComposite113 || (_feComposite113 = /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix141 || (_feColorMatrix141 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood57 || (_feFlood57 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend113 || (_feBlend113 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend114 || (_feBlend114 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix142 || (_feColorMatrix142 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite114 || (_feComposite114 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  })), _feColorMatrix143 || (_feColorMatrix143 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  })), _feComposite115 || (_feComposite115 = /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.665,
    k2: 1.813,
    operator: "arithmetic",
    result: "composite1"
  })), _feColorMatrix144 || (_feColorMatrix144 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  })), _feFlood58 || (_feFlood58 = /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#9E4300",
    floodOpacity: 1,
    result: "flood1"
  })), _feBlend115 || (_feBlend115 = /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  })), _feBlend116 || (_feBlend116 = /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  })), _feColorMatrix145 || (_feColorMatrix145 = /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  })), _feComposite116 || (_feComposite116 = /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.516 -39.516)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M39.516 39.516h40.329v40.329H39.516z",
    style: {
      fill: "#f2f2f2",
      fillOpacity: 0,
      strokeWidth: 0.264583,
      filter: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 39.74h5.611c1.23 0 2.219 1.123 2.219 2.52v34.689c0 1.396-.99 2.52-2.219 2.52H42c-1.23 0-2.22-1.124-2.22-2.52v-34.69c0-1.396.99-2.52 2.22-2.52",
    style: {
      fill: "#ffb380",
      strokeWidth: 0.387965,
      filter: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.601 39.74c-1.008 0-1.82 1.124-1.82 2.52v34.689c0 1.396.812 2.52 1.82 2.52h2.356V39.74Z",
    style: {
      fill: "#d38d5f",
      strokeWidth: 0.351427,
      filter: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78 46.114v3.706h10.05v-3.706z",
    style: {
      fill: "#784421",
      strokeWidth: 0.387965,
      filter: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78 69.856v2.858h10.05v-2.858Z",
    style: {
      fill: "#784421",
      strokeWidth: 0.387965,
      filter: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78 50.497v1.071h10.05v-1.071z",
    style: {
      fill: "#784421",
      strokeWidth: 0.387965,
      filter: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.78 67.927v.858h10.05v-.858z",
    style: {
      fill: "#784421",
      strokeWidth: 0.387965,
      filter: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.572,
    height: 37.219,
    x: 47.572,
    y: 40.781,
    ry: 1.097,
    style: {
      fill: "#fff",
      fillOpacity: 0.430279,
      strokeWidth: 0.430059,
      filter: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.414 39.74h3.847c.842 0 1.52 1.123 1.52 2.52v34.689c0 1.396-.678 2.52-1.52 2.52h-3.847c-.842 0-1.52-1.124-1.52-2.52v-34.69c0-1.396.678-2.52 1.52-2.52",
    style: {
      fill: "#ffb380",
      strokeWidth: 0.321206,
      filter: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.141 39.74c-.691 0-1.248 1.124-1.248 2.52v34.689c0 1.396.557 2.52 1.248 2.52h1.615V39.74Z",
    style: {
      fill: "#d38d5f",
      strokeWidth: 0.290955,
      filter: "url(#j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.893 46.114v3.706h6.889v-3.706z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.893 69.856v2.858h6.889v-2.858Z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.893 50.497v1.071h6.889v-1.071z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.893 67.927v.858h6.889v-.858z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.352 39.74h3.846c.843 0 1.521 1.123 1.521 2.52v34.689c0 1.396-.678 2.52-1.52 2.52h-3.847c-.843 0-1.521-1.124-1.521-2.52v-34.69c0-1.396.678-2.52 1.52-2.52",
    style: {
      fill: "#ffb380",
      strokeWidth: 0.321206,
      filter: "url(#o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.079 39.74c-.692 0-1.248 1.124-1.248 2.52v34.689c0 1.396.556 2.52 1.248 2.52h1.614V39.74Z",
    style: {
      fill: "#d38d5f",
      strokeWidth: 0.290955,
      filter: "url(#p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83 46.114v3.706h6.89v-3.706z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83 69.856v2.858h6.89v-2.858Z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83 50.497v1.071h6.89v-1.071z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#s)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.83 67.927v.858h6.89v-.858z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#t)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.323 40.43 3.782-.706c.828-.155 1.7.826 1.957 2.198l6.364 34.1c.256 1.373-.205 2.603-1.033 2.757l-3.781.706c-.828.154-1.701-.826-1.957-2.199l-6.364-34.1c-.256-1.373.204-2.602 1.032-2.757",
    style: {
      fill: "#ffb380",
      strokeWidth: 0.321206,
      filter: "url(#u)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.055 40.48c-.68.126-1.02 1.334-.764 2.706l6.363 34.1c.257 1.373 1.01 2.376 1.69 2.249l1.587-.296-7.289-39.056z",
    style: {
      fill: "#d38d5f",
      strokeWidth: 0.290955,
      filter: "url(#v)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.998 46.975.68 3.643 6.771-1.264-.68-3.643z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#w)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.353 70.313.525 2.81 6.771-1.264-.524-2.81z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#x)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.802 51.283.196 1.053 6.772-1.263-.197-1.054z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#y)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71 68.418.157.843 6.771-1.264-.157-.843z",
    style: {
      fill: "#784421",
      strokeWidth: 0.321206,
      filter: "url(#z)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.824,
    height: 37.219,
    x: 56.258,
    y: 40.781,
    ry: 1.097,
    style: {
      fill: "#fff",
      fillOpacity: 0.430279,
      strokeWidth: 0.311258,
      filter: "url(#A)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.824,
    height: 37.219,
    x: 64.195,
    y: 40.781,
    ry: 1.097,
    style: {
      fill: "#fff",
      fillOpacity: 0.430279,
      strokeWidth: 0.311258,
      filter: "url(#B)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.824,
    height: 37.219,
    x: 62.759,
    y: 53.434,
    ry: 1.097,
    style: {
      fill: "#fff",
      fillOpacity: 0.430279,
      strokeWidth: 0.311258,
      filter: "url(#C)"
    },
    transform: "rotate(-10.45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fa8543348dfb17487a0f566c8efda3f8.svg";
export { ForwardRef as ReactComponent };